import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useAuthStore from '../store/authStore';

/**
 * Página callback para OAuth — recibe tokens de la URL
 */
export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const { loginWithTokens } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = searchParams.get('access_token');
    const refreshToken = searchParams.get('refresh_token');
    const mustChangePassword = searchParams.get('must_change_password');

    if (accessToken && refreshToken) {
      loginWithTokens(accessToken, refreshToken, mustChangePassword).then(() => {
        if (mustChangePassword === 'true') {
          navigate('/change-password');
        } else {
          navigate('/dashboard');
        }
      });
    } else {
      navigate('/login');
    }
  }, [searchParams, loginWithTokens, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-500">Completando autenticación...</p>
      </div>
    </div>
  );
}
